import React from 'react';
import { Box } from '@chakra-ui/core';

import { FormSection } from '../../../../common/components/Form/Form';
import { RadioGroup, RadioInput } from '../../../../common/components/Form/FormInputs';
import { LockedInput } from '../../../../common/components/Form/FormLockedInput';
import { DateInput } from '../../../../common/components/Form/FormDateInput';
import { FundingDocumentsReviewPanel } from '../BlocC/FundingDocumentsReviewPanel';
import { BlocHForm } from './BlocHForm';

export const BlocHTab3 = ({ onDocumentsChanged, ...props }) => (
  <BlocHForm {...props}>
    {(formik, { hasHbCompanyTracking, folderId }) => {
      const projectEnded = hasHbCompanyTracking || Boolean(formik.values.projectEndReceivedAt);

      return (
        <>
          <FormSection title="Bilan de fin de projet">
            <LockedInput defaultIsLocked={!!formik.values.projectEndReviewPlannedAt} left="37%">
              <DateInput
                label="Dernière date de contact pour la programmation de bilan de fin de projet"
                name="projectEndReviewPlannedAt"
                id="projectEndReviewPlannedAt"
                enabledFutureDates
                disabled={!projectEnded}
              />
            </LockedInput>

            <RadioGroup name="isRecipientContacted" legend="Bénéficiaire contacté">
              <RadioInput value="true" disabled={!projectEnded}>
                Oui
              </RadioInput>
              <RadioInput value="false" disabled={!projectEnded}>
                Non
              </RadioInput>
            </RadioGroup>

            <DateInput
              label="Date de bilan de fin de projet"
              name="projectEndReviewDate"
              id="projectEndReviewDate"
              enabledFutureDates
              disabled={
                !formik.values.isRecipientContacted ||
                formik.values.isRecipientContacted === 'false'
              }
            />

            <RadioGroup name="bfpTransmissionType" legend="Modalité de passation du BFP">
              <RadioInput value="visit" disabled={!formik.values.projectEndReviewDate}>
                Visite à domicile
              </RadioInput>
              <RadioInput value="phone" disabled={!formik.values.projectEndReviewDate}>
                Téléphonique
              </RadioInput>
            </RadioGroup>

            <RadioGroup name="touchUp" legend="Résultat du BFP">
              <RadioInput value="true">Réserves</RadioInput>
              <RadioInput value="false">Absence de réserves</RadioInput>
            </RadioGroup>
          </FormSection>

          <Box>
            <FundingDocumentsReviewPanel
              folderId={folderId}
              onlyKey="amo_invoice"
              title="Facture AMO"
              intro="Cette pièce est la même que dans « Vérification des pièces »."
            />
            <FundingDocumentsReviewPanel
              folderId={folderId}
              section="project_end"
              onReviewed={onDocumentsChanged}
              title="Document d’évaluation de fin de projet"
              intro="Sa validation est nécessaire pour saisir la réception des pièces de déblocage des fonds."
            />
          </Box>
        </>
      );
    }}
  </BlocHForm>
);
